import React, { useMemo, useState } from 'react';
import styles from './Testimonials.module.scss';
import { useQuery } from '@apollo/client';
import GET_PAGE_DATA, { IPageData } from '../../data/get-data';
import { Header } from '../../components/Headers';
import { CardCarousel } from '../../components/CardCarousel';
import { isEmpty } from 'lodash';
import { PersonCard } from '../../components/Cards';
import { makeNumArray } from '../../utils';

const Testimonials = () => {
  const { data, loading, error } = useQuery<IPageData>(GET_PAGE_DATA);
  const skeletonData = makeNumArray(4).map((a, i) => ({
    loading,
    name: `Loading Skelington-${i}`,
    testimonial: 'Hello! Hello! Hello! I am the loading skelington from outer space :)',
  }));
  const cardsData = useMemo(() => {
    const testimonials = data?.page?.landingPage?.testimonials;
    if (!testimonials) return [];
    const { faculty = [], students = [] } = testimonials;
    return [...faculty, ...students];
  }, [data?.page?.landingPage?.testimonials]);
  const hasCardsData = !isEmpty(cardsData);
  return (
    <div>
      <div className={styles['container']}>
        <Header as="h2">SPITZER STARS</Header>
        <div className={styles['content']}>
          <div className={styles['left-block']}>
            <div className={styles['summary']}>
              We celebrate the achievements of our esteemed faculty members and alumni. Their
              significant impact on the fields of architecture, landscape architecture, and urban
              design—as well as on their communities—demonstrates the breadth and depth of a Spitzer
              education. In honor of their accomplishments, we created the Spitzer Stars project.
              You can see the full project{' '}
              <a href="https://ssa.ccny.cuny.edu/people/department/spitzer-stars/" rel="noreferrer">
                here
              </a>
              .
            </div>
          </div>
          {loading && !hasCardsData && (
            <CardCarousel>
              {(loading || error) &&
                skeletonData?.map((dummyData) => (
                  <PersonCard key={dummyData?.name} {...dummyData} />
                ))}
            </CardCarousel>
          )}
          {hasCardsData && (
            <CardCarousel>
              {cardsData?.map((person) => (
                <PersonCard
                  loading={loading}
                  key={`person-${person?.name}`}
                  name={person?.name}
                  position={person?.position}
                  src={person?.image?.link}
                  alt={person?.image?.altText}
                  testimonial={person?.testimonial}
                />
              ))}
            </CardCarousel>
          )}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
